import { toOutbox } from '@/lib/link'
import { SecondaryPageLink } from '@/PageManager'
import { useAtomValue } from 'jotai'
import { outboxChannelAtom } from '@/atoms/invalidation'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading03Icon } from '@hugeicons/core-free-icons'
import { useTranslation } from 'react-i18next'
import { useAsync } from 'react-use'
import { loadRelayList } from '@nostr/gadgets/lists'

export default function OutboxCount({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const channel = useAtomValue(outboxChannelAtom)
  const { value: rl, loading } = useAsync(() => loadRelayList(pubkey), [pubkey, channel])

  return (
    <SecondaryPageLink
      to={toOutbox(pubkey)}
      className="flex gap-1 hover:underline w-fit items-center text-xs"
    >
      {loading ? (
        <HugeiconsIcon icon={Loading03Icon} className="animate-spin size-3" />
      ) : (
        rl?.items.filter((r) => r.write).length
      )}
      <div className="text-muted-foreground">{t('Outbox')}</div>
    </SecondaryPageLink>
  )
}
